import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { BankEmployeesModel, TimeOffModel, SubstitutionInfoModel } from 'Pages/bankEmployees'

export type BankEmployeesState = {
	reload: boolean
	data: ResponseCatalog<BankEmployeesModel>
	requestParams: RequestParams
	isLoading: boolean
	substitutionInfo: SubstitutionInfoModel
}

export const BankEmployeesInitialState: BankEmployeesState = {
	reload: false,
	data: new ResponseCatalog<BankEmployeesModel>(),
	requestParams: new RequestParams(),
	isLoading: false,
	substitutionInfo: null,
}

export namespace BankEmployeesNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Function
	}>
	export type UpdateOne = PayloadAction<{
		id: string
		data: TimeOffModel
		callback?: Function
	}>
	export type CreateOne = PayloadAction<{
		data: TimeOffModel
		callback?: Function
	}>
	export type SetAll = PayloadAction<ResponseCatalog<BankEmployeesModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetOne = PayloadAction<{
		id: string
		callback?: Function
	}>
	export type GetSubstitutionInfo = PayloadAction
	export type SetSubstitutionInfo = PayloadAction<SubstitutionInfoModel>
	export type GetLoginSubstitution = PayloadAction<string>
}

export const bankEmployeesSlice = createSlice({
	name: 'bankEmployees',
	initialState: BankEmployeesInitialState,
	reducers: {
		getAll: (state, action: BankEmployeesNS.GetAll) => {},
		setAll: (state, action: BankEmployeesNS.SetAll) => {
			state.data = action.payload
		},
		setRequestParams: (state, action: BankEmployeesNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.data = new ResponseCatalog<BankEmployeesModel>()
			state.requestParams = new RequestParams()
		},
		setIsLoading: (state, action: BankEmployeesNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		updateOne: (state, action: BankEmployeesNS.UpdateOne) => {},
		createOne: (state, action: BankEmployeesNS.CreateOne) => {},
		getOne: (state, action: BankEmployeesNS.GetOne) => {},
		getSubstitutionInfo: (state, action: BankEmployeesNS.GetSubstitutionInfo) => {},
		setSubstitutionInfo: (state, action: BankEmployeesNS.SetSubstitutionInfo) => {
			state.substitutionInfo = action.payload
		},
		getLoginSubstitution: (state, action: BankEmployeesNS.GetLoginSubstitution) => {},
	},
})
